import { render, staticRenderFns } from "./issmccmap.vue?vue&type=template&id=2c2b2833&scoped=true&"
import script from "./issmccmap.vue?vue&type=script&lang=ts&"
export * from "./issmccmap.vue?vue&type=script&lang=ts&"
import style0 from "./issmccmap.vue?vue&type=style&index=0&id=2c2b2833&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b2833",
  null
  
)

export default component.exports